import { useState } from "react";
import { TrendingUp, X } from "lucide-react";

/* Hub home notice: "N cost prices changed this week" → opens the price list filtered to them. */
export const PriceChangeNotice = ({ data, onOpen }) => {
  const key = data?.items?.length ? `pl-notice-${data.items.map((x) => x.at).sort().pop()}` : "";
  const [hid, setHid] = useState(() => !!key && localStorage.getItem("pl-notice-hidden") === key);
  if (!data?.count || hid || localStorage.getItem("pl-notice-hidden") === key) return null;
  const hide = () => { localStorage.setItem("pl-notice-hidden", key); setHid(true); };
  return (
    <div className="mb-3 flex items-center gap-3 rounded-xl border border-amber-300 bg-amber-50 px-3 py-2 text-sm" data-testid="pl-change-notice">
      <TrendingUp className="h-4 w-4 shrink-0 text-amber-700" />
      <span className="text-amber-900"><b data-testid="pl-change-notice-count">{data.count}</b> cost price(s) changed this week — check your sale prices.</span>
      <button onClick={onOpen} className="ml-auto rounded-lg bg-amber-600 px-3 py-1 text-xs font-semibold text-white" data-testid="pl-change-notice-open">View</button>
      <button onClick={hide} className="text-amber-700" title="Hide until prices change again" data-testid="pl-change-notice-hide"><X className="h-4 w-4" /></button>
    </div>
  );
};

export const normKey = (s) => String(s || "").toUpperCase().replace(/[^A-Z0-9]/g, "");
